import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { config, getClientId, getCookieDomain, getEnv } from './config';
import Cookies from 'js-cookie';
export function sendNewRelicEvent(eventData) {
  var env = getEnv();
  var newRelic = config[env].newRelic;
  var url = "https://insights-collector.newrelic.com/v1/accounts/".concat(newRelic.id, "/events");
  var location = typeof window != 'undefined' ? window.location : null;
  var data = _objectSpread({
    env: env,
    eventType: 'OneAuthSdkEvent',
    clientId: getClientId(),
    domain: getCookieDomain(),
    website: location === null || location === void 0 ? void 0 : location.host,
    path: location === null || location === void 0 ? void 0 : location.pathname,
    callTimestamp: Date.now(),
    sessionId: Cookies.get('CSessionID'),
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : 'unknown',
    url: typeof window !== 'undefined' ? window.location.href : 'unknown'
  }, eventData);
  var nrEventBody = JSON.stringify(data);
  return fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-insert-Key': newRelic.key
    },
    body: nrEventBody
  });
}